// import React, { useEffect, useState } from "react";
// import {
//   Table,
//   Button,
//   Space,
//   Image,
//   Tag,
//   message,
//   Card,
//   Spin,
//   Descriptions,
//   Layout,
//   Tooltip,
//   Input,
//   Select,
//   Typography
// } from "antd";

// import {
//   CheckOutlined,
//   CloseOutlined,
//   EyeOutlined,
//   DeleteOutlined,
//   EditOutlined,
// } from "@ant-design/icons";
// import { MdPending } from "react-icons/md";
// import { FaCircleCheck } from "react-icons/fa6";
// import countries from "world-countries";

// import ModernModal from "../Components/ModernModal";
// import Sidebar from "../Components/Sidebar";
// import { BASE_URL } from "../Config";
// import axios from "axios";
// import { Form } from "antd";
// import { Upload } from "antd";
// import { PlusOutlined } from "@ant-design/icons";
// import SuccessPopup from "../Components/popup/SuccessPopup";
// import ErrorPopup from "../Components/popup/ErrorPopup";
// import { MenuOutlined } from "@ant-design/icons";

// const { Header, Content } = Layout;
// const { Title, Paragraph, Text } = Typography;


// const AdminVariationApproval = () => {
//   const [form] = Form.useForm();

//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [collapsed, setCollapsed] = useState(false);
//   const [isMobile, setIsMobile] = useState(false);
//   const [mobileOpen, setMobileOpen] = useState(false);
//   const [updateLoading, setUpdateLoading] = useState(false);

//   const [popupVisible, setPopupVisible] = useState(false);
//   const [popupType, setPopupType] = useState(null);
//   const [popupRecord, setPopupRecord] = useState(null);
//   const [popupLoading, setPopupLoading] = useState(false);
//   const [imageFile, setImageFile] = useState(null);
//   const [successPopup, setSuccessPopup] = useState(false);
//   const [errorPopup, setErrorPopup] = useState(false);
//   const token = sessionStorage.getItem("token");
//   const [editForm] = Form.useForm();

//   const countryOptions = countries
//     .map((c) => ({
//       label: c.name.common,
//       value: c.name.common,
//     }))
//     .sort((a, b) => a.label.localeCompare(b.label));

//   useEffect(() => {
//     fetchAll();
//   }, []);

//   useEffect(() => {
//     const check = () => setIsMobile(window.innerWidth <= 768);
//     check();
//     window.addEventListener("resize", check);
//     return () => window.removeEventListener("resize", check);
//   }, []);

//   const fetchAll = async () => {
//     try {
//       const res = await axios.get(`${BASE_URL}/uservariations`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });

//       let arr = res?.data?.variations || [];
//       arr = Object.values(arr).filter((x) => typeof x === "object");

//       setData(arr);
//     } catch (err) {
//       message.error("Failed to load variations");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const openViewPopup = async (id) => {
//     setPopupVisible(true);
//     setPopupType("view");
//     setPopupLoading(true);

//     try {
//       const res = await axios.get(`${BASE_URL}/uservariations/${id}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });

//       if (res.data.success) {
//         setPopupRecord(res.data.variation);
//       }
//     } catch {
//       message.error("Failed to fetch details");
//     } finally {
//       setPopupLoading(false);
//     }
//   };

//   const handleApprove = async () => {
//     try {
//       const res = await axios.put(
//         `${BASE_URL}/uservariations/approve/${popupRecord._id}`,
//         {},
//         { headers: { Authorization: `Bearer ${token}` } },
//       );

//       if (res.data.success) {
//         message.success("Approved successfully");
//         setPopupVisible(false);
//         fetchAll();
//       }
//     } catch {
//       message.error("Approve failed");
//     }
//   };

//   const openEditPopup = (record) => {
//     setPopupType("edit");
//     setPopupRecord(record);
//     setPopupVisible(true);
//     setImageFile(null); // important

//     editForm.setFieldsValue({
//       name: record.name,
//       sanskrit: record.sanskrit,
//       english: record.english,
//       country: record.country,
//       mediaLink: record.mediaLink,
//       poseType: record.poseType?.join(", "),
//       parentAsana: record.parentAsana,
//     });
//   };

//   const handleUpdate = async (values) => {
//     try {
//       setUpdateLoading(true);

//       const formData = new FormData();
//       formData.append("name", values.name);
//       formData.append("sanskrit", values.sanskrit || "");
//       formData.append("english", values.english || "");
//       formData.append("country", values.country || "");
//       formData.append("mediaLink", values.mediaLink || "");
//       formData.append("parentAsana", values.parentAsana);

//       const poseTypes = values.poseType
//         ? values.poseType.split(",").map((p) => p.trim().toLowerCase())
//         : [];

//       poseTypes.forEach((p) => formData.append("poseType[]", p));

//       if (imageFile) {
//         formData.append("image", imageFile);
//       }

//       const res = await axios.put(
//         `${BASE_URL}/uservariations/${popupRecord._id}`,
//         formData,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "multipart/form-data",
//           },
//         },
//       );

//       if (res.data.success) {
//         setPopupVisible(false);
//         setSuccessPopup(true);
//         fetchAll();
//       } else {
//         setErrorPopup(true);
//       }
//     } catch (err) {
//       setErrorPopup(true);
//     } finally {
//       setUpdateLoading(false); // ✅ always stop loading
//     }
//   };

//   const handleReject = async () => {
//     try {
//       const res = await axios.put(
//         `${BASE_URL}/uservariations/reject/${popupRecord._id}`,
//         {},
//         { headers: { Authorization: `Bearer ${token}` } },
//       );

//       if (res.data.success) {
//         message.success("Rejected");
//         setPopupVisible(false);
//         fetchAll();
//       }
//     } catch {
//       message.error("Reject failed");
//     }
//   };

//   const handleDelete = async () => {
//     try {
//       const res = await axios.delete(
//         `${BASE_URL}/uservariations/${popupRecord._id}`,
//         { headers: { Authorization: `Bearer ${token}` } },
//       );

//       if (res.data.success) {
//         message.success("Deleted successfully");
//         setPopupVisible(false);
//         fetchAll();
//       } else {
//         message.error(res.data.message);
//       }
//     } catch {
//       message.error("Delete failed");
//     }
//   };

//   const parseTypes = (t) => {
//     try {
//       if (!t) return [];
//       if (t.startsWith("[")) return JSON.parse(t);
//       if (t.includes(",")) return t.split(",").map((a) => a.trim());
//       return [t];
//     } catch {
//       return [t];
//     }
//   };

//   const columns = [
//     {
//       title: "Image",
//       dataIndex: "image",
//       align: "center",
//       render: (img) => (
//         <Image
//           preview={true}
//           width={70}
//           height={70}
//           src={img}
//           style={{
//             borderRadius: 8,
//             objectFit: "cover",
//             boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
//             transition: "0.3s",
//           }}
//         />
//       ),
//     },
//     {
//       title: "Name",
//       dataIndex: "name",
//       render: (t) => <strong style={{ fontSize: 15 }}>{t}</strong>,
//     },

//     {
//       title: "Pose Type",
//       dataIndex: "poseType",
//       render: (t) =>
//         parseTypes(t).map((p, i) => (
//           <Tag
//             key={i}
//             color="geekblue"
//             style={{
//               padding: "4px 10px",
//               borderRadius: "30px",
//               fontSize: 12,
//             }}
//           >
//             {p}
//           </Tag>
//         )),
//     },

//     {
//       title: "Media link staus",
//       dataIndex: "mediaLinkStatus",
//       render: (l) => (
//         <Tag
//           color="green"
//           style={{ padding: "4px 12px", borderRadius: 30, fontSize: 12 }}
//         >
//           {l}
//         </Tag>
//       ),
//     },

//     {
//       title: "Status",
//       dataIndex: "status",
//       render: (s) => (
//         <Tag
//           color={
//             s === "approved" ? "green" : s === "rejected" ? "red" : "orange"
//           }
//           style={{
//             padding: "6px 14px",
//             borderRadius: 30,
//             fontSize: 12,
//             fontWeight: 600,
//           }}
//         >
//           {s.toUpperCase()}
//         </Tag>
//       ),
//     },

//     {
//       title: "Actions",
//       align: "center",
//       render: (_, record) => (
//         <Space size="middle">
//           <Tooltip title="View Details">
//             <Button
//               icon={<EyeOutlined />}
//               onClick={() => openViewPopup(record._id)}
//               shape="circle"
//             />
//           </Tooltip>
//           <Tooltip title="Edit">
//             <Button
//               icon={<EditOutlined />}
//               onClick={() => openEditPopup(record)}
//               shape="circle"
//             />
//           </Tooltip>

//           <Tooltip title="Approve">
//             <Button
//               icon={<CheckOutlined />}
//               type="primary"
//               shape="circle"
//               style={{ background: "#10b981", borderColor: "#10b981" }}
//               disabled={record.status === "approved"}
//               onClick={() => {
//                 setPopupType("approve");
//                 setPopupRecord(record);
//                 setPopupVisible(true);
//               }}
//             />
//           </Tooltip>

//           <Tooltip title="Reject">
//             <Button
//               icon={<CloseOutlined />}
//               danger
//               shape="circle"
//               disabled={record.status === "rejected"}
//               onClick={() => {
//                 setPopupType("reject");
//                 setPopupRecord(record);
//                 setPopupVisible(true);
//               }}
//             />
//           </Tooltip>

//           <Tooltip title="Delete Permanently">
//             <Button
//               icon={<DeleteOutlined />}
//               danger
//               shape="circle"
//               onClick={() => {
//                 setPopupType("delete");
//                 setPopupRecord(record);
//                 setPopupVisible(true);
//               }}
//             />
//           </Tooltip>
//         </Space>
//       ),
//     },
//   ];

//   const formDate = () => {
//     const date = new Date(
//       popupRecord.mediaLinkStartDate || popupRecord.mediaLinkExpiryDate * 1000,
//     ).toLocaleString("en-US", {
//       day: "numeric",
//       month: "long",
//       year: "numeric",
//     });

//     return date;
//   };

//   const MobileVariationApprovalCard = ({ item }) => {

//     const statusColor =
//       item.status === "approved"
//         ? "green"
//         : item.status === "rejected"
//           ? "red"
//           : "orange";

//     return (
//       <Card
//         style={{
//           marginBottom: 16,
//           borderRadius: 16,
//         }}
//         bodyStyle={{ padding: 14 }}
//       >

//         {/* Top Row */}

//         <div
//           style={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//           }}
//         >

//           <Space>

//             <Image
//               src={item.image}
//               width={55}
//               height={55}
//               style={{
//                 borderRadius: 10,
//                 objectFit: "cover"
//               }}
//             />

//             <div>

//               <div style={{
//                 fontWeight: 600,
//                 fontSize: 16
//               }}>
//                 {item.name}
//               </div>

//               <div style={{
//                 fontSize: 12,
//                 color: "#777"
//               }}>
//                 {parseTypes(item.poseType).join(", ")}
//               </div>

//             </div>

//           </Space>


//           <Tag color={statusColor}>
//             {item.status.toUpperCase()}
//           </Tag>

//         </div>


//         {/* Media Link Status */}

//         <div style={{ marginTop: 10 }}>
//           <Tag color="blue">
//             {item.mediaLinkStatus}
//           </Tag>
//         </div>


//         {/* Actions */}

//         <div
//           style={{
//             display: "flex",
//             justifyContent: "flex-end",
//             gap: 8,
//             marginTop: 14
//           }}
//         >

//           <Button
//             icon={<EyeOutlined />}
//             onClick={() => openViewPopup(item._id)}
//           />

//           <Button
//             icon={<EditOutlined />}
//             onClick={() => openEditPopup(item)}
//           />

//           <Button
//             icon={<CheckOutlined />}
//             type="primary"
//             style={{
//               background: "#10b981",
//               borderColor: "#10b981"
//             }}
//             disabled={item.status === "approved"}
//             onClick={() => {
//               setPopupType("approve");
//               setPopupRecord(item);
//               setPopupVisible(true);
//             }}
//           />

//           <Button
//             icon={<CloseOutlined />}
//             danger
//             disabled={item.status === "rejected"}
//             onClick={() => {
//               setPopupType("reject");
//               setPopupRecord(item);
//               setPopupVisible(true);
//             }}
//           />

//           <Button
//             icon={<DeleteOutlined />}
//             danger
//             onClick={() => {
//               setPopupType("delete");
//               setPopupRecord(item);
//               setPopupVisible(true);
//             }}
//           />

//         </div>

//       </Card>
//     );
//   };

//   return (
//     <Layout style={{ minHeight: "100vh", background: "#f5f7fa" }}>
//       <Sidebar
//         collapsed={collapsed}
//         setCollapsed={setCollapsed}
//         mobileOpen={mobileOpen}
//         setMobileOpen={setMobileOpen}
//         isMobile={isMobile}
//         collapsedWidth="0"
//         role="admin"
//       />
//       <div
//         className="main-layout"
//         style={{
//           marginLeft: isMobile ? 0 : collapsed ? 0 : 240,
//           transition: "0.3s",
//           padding: isMobile ? 10 : 20,
//         }}
//       >
//         <Header
//           className="MainHeader"
//         >
//           {isMobile && (
//             <Button
//               type="text"
//               icon={<MenuOutlined />}
//               onClick={() => setMobileOpen(true)}
//               style={{ fontSize: 18, marginRight: 12 }}
//             />
//           )}
//           <div style={{ flex: 1 }}>
//             <Text style={{ fontSize: 20, fontWeight: "bold" }}>User Submitted Variations</Text>
//           </div>
//         </Header>
//         <Card
//           style={{
//             borderRadius: 16,
//             padding: 10,
//             boxShadow: "0 6px 20px rgba(0,0,0,0.1)",
//           }}
//         >
//           {
//             isMobile ? (

//               loading ? (
//                 <Spin />
//               ) : (
//                 data.map(item => (
//                   <MobileVariationApprovalCard
//                     key={item._id}
//                     item={item}
//                   />
//                 ))
//               )

//             ) : (

//               <Table
//                 columns={columns}
//                 dataSource={data}
//                 rowKey="_id"
//                 loading={loading}
//                 pagination={{ pageSize: 6 }}
//               />

//             )
//           }
//         </Card>

//         <ModernModal
//           open={popupVisible}
//           title={
//             popupType === "view"
//               ? "Variation Details"
//               : popupType === "approve"
//                 ? "Approve Variation"
//                 : popupType === "reject"
//                   ? "Reject Variation"
//                   : popupType === "edit"
//                     ? "Edit Variation"
//                     : "Delete Variation"
//           }
//           onCancel={() => setPopupVisible(false)}
//           cancelText="Close" // ✅ Close button added
//           onOk={
//             popupType === "approve"
//               ? handleApprove
//               : popupType === "reject"
//                 ? handleReject
//                 : popupType === "delete"
//                   ? handleDelete
//                   : () => setPopupVisible(false)
//           }
//           okText={
//             popupType === "approve"
//               ? "Approve"
//               : popupType === "reject"
//                 ? "Reject"
//                 : popupType === "delete"
//                   ? "Delete"
//                   : "Close"
//           }
//           showFooter={popupType !== "view"}
//           width={popupType === "view" ? 600 : 380}
//         >
//           {popupType === "view" && (
//             <>
//               {popupLoading ? (
//                 <Spin size="large" />
//               ) : popupRecord ? (
//                 <Descriptions bordered size="small" column={1}>
//                   <Descriptions.Item label="name">
//                     {popupRecord?.name}
//                   </Descriptions.Item>

//                   <Descriptions.Item label="Sanskrit">
//                     {popupRecord?.sanskrit}
//                   </Descriptions.Item>

//                   <Descriptions.Item label="English">
//                     {popupRecord?.english}
//                   </Descriptions.Item>

//                   <Descriptions.Item label="Pose Type">
//                     {parseTypes(popupRecord?.poseType).join(", ")}
//                   </Descriptions.Item>

//                   <Descriptions.Item label="Status">
//                     {popupRecord?.status === "pending" ? (
//                       <div className="status">
//                         <p style={{ margin: "0px" }}>Pending </p>
//                         <MdPending color="#d36a0e" />
//                       </div>
//                     ) : (
//                       <div className="status">
//                         <p style={{ margin: "0px" }}>Approved </p>
//                         <FaCircleCheck color="#34c608" />
//                       </div>
//                     )}
//                   </Descriptions.Item>

//                   <Descriptions.Item label="mediaLink">
//                     <a href={popupRecord?.mediaLink}>
//                       {popupRecord?.mediaLink}
//                     </a>
//                   </Descriptions.Item>

//                   <Descriptions.Item label="parentAsana">
//                     {popupRecord?.parentAsana?.name}
//                   </Descriptions.Item>

//                   <Descriptions.Item label="MediaLink Start Date">
//                     {formDate(popupRecord?.mediaLinkStartDate)}
//                   </Descriptions.Item>

//                   <Descriptions.Item label="MediaLink Expiry Date">
//                     {formDate(popupRecord?.mediaLinkExpiryDate)}
//                   </Descriptions.Item>

//                   <Descriptions.Item label="Image">
//                     <Image
//                       width={260}
//                       src={popupRecord?.image}
//                       style={{
//                         borderRadius: 10,
//                         boxShadow: "0 4px 14px rgba(0,0,0,0.2)",
//                       }}
//                     />
//                   </Descriptions.Item>
//                 </Descriptions>
//               ) : (
//                 "No Data Found"
//               )}

//               <div style={{ position: "absolute", top: 10, right: 10 }}>
//                 <Button onClick={() => setPopupVisible(false)}>
//                   <CloseOutlined />
//                 </Button>
//               </div>
//             </>
//           )}

//           {popupType === "approve" && (
//             <p>
//               Are you sure you want to{" "}
//               <strong style={{ color: "#10b981" }}>Approve</strong> this
//               variation?
//             </p>
//           )}

//           {popupType === "edit" && (
//             <Form
//               layout="vertical"
//               form={editForm}
//               onFinish={handleUpdate}
//               disabled={updateLoading}
//             >
//               <Form.Item label="Name" name="name" rules={[{ required: true }]}>
//                 <Input />
//               </Form.Item>

//               <Form.Item label="Sanskrit" name="sanskrit">
//                 <Input />
//               </Form.Item>

//               <Form.Item label="English" name="english">
//                 <Input />
//               </Form.Item>

//               <Form.Item
//                 label="Country"
//                 name="country"
//                 rules={[{ required: true, message: "Please select country" }]}
//               >
//                 <Select
//                   showSearch
//                   placeholder="Select country"
//                   options={countryOptions}
//                   optionFilterProp="label"
//                   getPopupContainer={(node) => node.parentNode}
//                 />
//               </Form.Item>

//               <Form.Item label="Pose Type (comma separated)" name="poseType">
//                 <Input placeholder="seated, forward" />
//               </Form.Item>

//               <Form.Item
//                 label="Media Link"
//                 name="mediaLink"
//                 rules={[{ type: "url", message: "Enter valid URL" }]}
//               >
//                 <Input />
//               </Form.Item>

//               {/* hidden but required */}
//               <Form.Item name="parentAsana" hidden>
//                 <Input />
//               </Form.Item>

//               <Form.Item label="Current Image">
//                 <Image
//                   width={160}
//                   src={popupRecord?.image}
//                   style={{ borderRadius: 8 }}
//                 />
//               </Form.Item>

//               <Form.Item label="Upload New Image">
//                 <Upload
//                   listType="picture-card"
//                   maxCount={1}
//                   beforeUpload={(file) => {
//                     setImageFile(file);
//                     return false; // prevent auto upload
//                   }}
//                 >
//                   {!imageFile && (
//                     <div>
//                       <PlusOutlined />
//                       <div style={{ marginTop: 8 }}>Upload</div>
//                     </div>
//                   )}
//                 </Upload>
//               </Form.Item>

//               <Button
//                 type="primary"
//                 htmlType="submit"
//                 block
//                 loading={updateLoading}
//                 disabled={updateLoading}
//               >
//                 {updateLoading ? "Updating..." : "Update"}
//               </Button>
//             </Form>
//           )}

//           {popupType === "reject" && (
//             <p>
//               Are you sure you want to{" "}
//               <strong style={{ color: "red" }}>Reject</strong> this variation?
//             </p>
//           )}

//           {popupType === "delete" && (
//             <p>
//               Are you sure you want to{" "}
//               <strong style={{ color: "red" }}>Delete Permanently</strong> this
//               variation?
//             </p>
//           )}
//         </ModernModal>
//         <SuccessPopup
//           open={successPopup}
//           onClose={() => setSuccessPopup(false)}
//           message="variation updated successfully!"
//           navigate="/var-approval"
//         />

//         <ErrorPopup
//           open={errorPopup}
//           onClose={() => setErrorPopup(false)}
//           message="Upload failed. Try again."
//         />
//       </div>
//     </Layout>
//   );
// };

// export default AdminVariationApproval;

import React, { useEffect, useState } from "react";
import {
  Table, Button, Space, Image, Tag, message, Card, Spin,
  Descriptions, Layout, Tooltip, Input, Select, Typography, Form, Upload,
} from "antd";
import {
  CheckOutlined, CloseOutlined, EyeOutlined, DeleteOutlined,
  EditOutlined, MenuOutlined, PlusOutlined,
} from "@ant-design/icons";
import { MdPending } from "react-icons/md";
import { FaCircleCheck } from "react-icons/fa6";
import countries from "world-countries";

import ModernModal from "../Components/ModernModal";
import Sidebar from "../Components/Sidebar";
import { BASE_URL } from "../Config";
import axios from "axios";
import SuccessPopup from "../Components/popup/SuccessPopup";
import ErrorPopup from "../Components/popup/ErrorPopup";

const { Header, Content } = Layout;
const { Text } = Typography;

const AdminVariationApproval = () => {
  const [form] = Form.useForm();
  const [editForm] = Form.useForm();

  const [data, setData]               = useState([]);
  const [loading, setLoading]         = useState(true);
  const [collapsed, setCollapsed]     = useState(false);
  const [isMobile, setIsMobile]       = useState(false);
  const [mobileOpen, setMobileOpen]   = useState(false);
  const [updateLoading, setUpdateLoading] = useState(false);

  const [popupVisible, setPopupVisible]   = useState(false);
  const [popupType, setPopupType]         = useState(null);
  const [popupRecord, setPopupRecord]     = useState(null);
  const [popupLoading, setPopupLoading]   = useState(false);
  const [imageFile, setImageFile]         = useState(null);
  const [successPopup, setSuccessPopup]   = useState(false);
  const [errorPopup, setErrorPopup]       = useState(false);

  const token = sessionStorage.getItem("token");

  const countryOptions = countries
    .map((c) => ({ label: c.name.common, value: c.name.common }))
    .sort((a, b) => a.label.localeCompare(b.label));

  useEffect(() => { fetchAll(); }, []);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth <= 768);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  const fetchAll = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/uservariations`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      let arr = res?.data?.variations || [];
      arr = Object.values(arr).filter((x) => typeof x === "object");
      setData(arr);
    } catch {
      message.error("Failed to load variations");
    } finally {
      setLoading(false);
    }
  };

  const openViewPopup = async (id) => {
    setPopupVisible(true);
    setPopupType("view");
    setPopupLoading(true);
    try {
      const res = await axios.get(`${BASE_URL}/uservariations/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.data.success) setPopupRecord(res.data.variation);
    } catch {
      message.error("Failed to fetch details");
    } finally {
      setPopupLoading(false);
    }
  };

  const handleApprove = async () => {
    try {
      const res = await axios.put(
        `${BASE_URL}/uservariations/approve/${popupRecord._id}`,
        {}, { headers: { Authorization: `Bearer ${token}` } }
      );
      if (res.data.success) {
        message.success("Approved successfully");
        setPopupVisible(false);
        fetchAll();
      }
    } catch { message.error("Approve failed"); }
  };

  const openEditPopup = (record) => {
    setPopupType("edit");
    setPopupRecord(record);
    setPopupVisible(true);
    setImageFile(null);
    editForm.setFieldsValue({
      name: record.name,
      sanskrit: record.sanskrit,
      english: record.english,
      country: record.country,
      mediaLink: record.mediaLink,
      poseType: Array.isArray(record.poseType) ? record.poseType.join(", ") : record.poseType,
      parentAsana: record.parentAsana,
    });
  };

  const handleUpdate = async (values) => {
    try {
      setUpdateLoading(true);
      const formData = new FormData();
      formData.append("name", values.name);
      formData.append("sanskrit", values.sanskrit || "");
      formData.append("english", values.english || "");
      formData.append("country", values.country || "");
      formData.append("mediaLink", values.mediaLink || "");
      formData.append("parentAsana", values.parentAsana);
      const poseTypes = values.poseType
        ? values.poseType.split(",").map((p) => p.trim().toLowerCase())
        : [];
      poseTypes.forEach((p) => formData.append("poseType[]", p));
      if (imageFile) formData.append("image", imageFile);

      const res = await axios.put(
        `${BASE_URL}/uservariations/${popupRecord._id}`,
        formData,
        { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } }
      );
      if (res.data.success) {
        setPopupVisible(false);
        setSuccessPopup(true);
        fetchAll();
      } else { setErrorPopup(true); }
    } catch { setErrorPopup(true); }
    finally { setUpdateLoading(false); }
  };

  const handleReject = async () => {
    try {
      const res = await axios.put(
        `${BASE_URL}/uservariations/reject/${popupRecord._id}`,
        {}, { headers: { Authorization: `Bearer ${token}` } }
      );
      if (res.data.success) {
        message.success("Rejected");
        setPopupVisible(false);
        fetchAll();
      }
    } catch { message.error("Reject failed"); }
  };

  const handleDelete = async () => {
    try {
      const res = await axios.delete(
        `${BASE_URL}/uservariations/${popupRecord._id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (res.data.success) {
        message.success("Deleted successfully");
        setPopupVisible(false);
        fetchAll();
      } else { message.error(res.data.message); }
    } catch { message.error("Delete failed"); }
  };

  const parseTypes = (t) => {
    try {
      if (!t) return [];
      if (t.startsWith("[")) return JSON.parse(t);
      if (t.includes(",")) return t.split(",").map((a) => a.trim());
      return [t];
    } catch { return [t]; }
  };

 const formDate = (dateVal) => {
  if (!dateVal) return "N/A";
  return new Date(dateVal).toLocaleString("en-US", {
    day: "numeric", month: "long", year: "numeric"
  });
};

  const statusColor = (s) =>
    s === "approved" ? "green" : s === "rejected" ? "red" : "orange";

  // ── Desktop columns ──────────────────────────────────────
  const columns = [
    {
      title: "Image",
      dataIndex: "image",
      align: "center",
      render: (img) => (
        <Image preview width={70} height={70} src={img}
          style={{ borderRadius: 8, objectFit: "cover", boxShadow: "0 4px 12px rgba(0,0,0,0.15)" }}
        />
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
      render: (t) => <strong style={{ fontSize: 15 }}>{t}</strong>,
    },
    {
      title: "Pose Type",
      dataIndex: "poseType",
      render: (t) =>
        parseTypes(t).map((p, i) => (
          <Tag key={i} color="geekblue" style={{ padding: "4px 10px", borderRadius: 30, fontSize: 12 }}>
            {p}
          </Tag>
        )),
    },
    {
      title: "Media Link Status",
      dataIndex: "mediaLinkStatus",
     render: (l) => (
  <Tag color={l === "active" ? "green" : l === "expired" ? "red" : "orange"}>
    {l}
  </Tag>
)
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (s) => (
        <Tag color={statusColor(s)}
          style={{ padding: "6px 14px", borderRadius: 30, fontSize: 12, fontWeight: 600 }}>
          {s.toUpperCase()}
        </Tag>
      ),
    },
    {
      title: "Actions",
      align: "center",
      render: (_, record) => (
        <Space size="middle">
          <Tooltip title="View Details">
            <Button icon={<EyeOutlined />} shape="circle" onClick={() => openViewPopup(record._id)} />
          </Tooltip>
          <Tooltip title="Edit">
            <Button icon={<EditOutlined />} shape="circle" onClick={() => openEditPopup(record)} />
          </Tooltip>
          <Tooltip title="Approve">
            <Button icon={<CheckOutlined />} type="primary" shape="circle"
              style={{ background: "#10b981", borderColor: "#10b981" }}
              disabled={record.status === "approved"}
              onClick={() => { setPopupType("approve"); setPopupRecord(record); setPopupVisible(true); }}
            />
          </Tooltip>
          <Tooltip title="Reject">
            <Button icon={<CloseOutlined />} danger shape="circle"
              disabled={record.status === "rejected"}
              onClick={() => { setPopupType("reject"); setPopupRecord(record); setPopupVisible(true); }}
            />
          </Tooltip>
          <Tooltip title="Delete Permanently">
            <Button icon={<DeleteOutlined />} danger shape="circle"
              onClick={() => { setPopupType("delete"); setPopupRecord(record); setPopupVisible(true); }}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  // ── Mobile card ──────────────────────────────────────────
  const MobileCard = ({ item }) => (
    <Card
      style={{ marginBottom: 12, borderRadius: 14, boxShadow: "0 1px 6px rgba(0,0,0,0.08)" }}
      bodyStyle={{ padding: "12px 14px" }}
    >
      {/* Row 1 – Image + Name + Status */}
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 10 }}>
        <Image
          src={item.image} width={56} height={56} preview
          style={{ borderRadius: 10, objectFit: "cover", flexShrink: 0 }}
        />
        <div style={{ flex: 1, minWidth: 0 }}>
          <Text strong style={{ fontSize: 15, display: "block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
            {item.name}
          </Text>
          <Text type="secondary" style={{ fontSize: 12 }}>
            {parseTypes(item.poseType).join(", ")}
          </Text>
        </div>
        <Tag color={statusColor(item.status)}
          style={{ borderRadius: 20, padding: "2px 10px", fontWeight: 600, flexShrink: 0 }}>
          {item.status.toUpperCase()}
        </Tag>
      </div>

      {/* Row 2 – Media link status */}
      <div style={{ marginBottom: 12 }}>
        <Tag color="green" style={{ borderRadius: 20, padding: "2px 10px", fontSize: 12 }}>
          {item.mediaLinkStatus}
        </Tag>
      </div>

      {/* Row 3 – Actions: 2 rows of buttons */}
      <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
        <Button icon={<EyeOutlined />} style={{ flex: "1 1 0" }}
          onClick={() => openViewPopup(item._id)}>
          View
        </Button>
        <Button icon={<EditOutlined />} style={{ flex: "1 1 0" }}
          onClick={() => openEditPopup(item)}>
          Edit
        </Button>
        <Button icon={<CheckOutlined />} type="primary"
          style={{ flex: "1 1 0", background: "#10b981", borderColor: "#10b981" }}
          disabled={item.status === "approved"}
          onClick={() => { setPopupType("approve"); setPopupRecord(item); setPopupVisible(true); }}>
          Approve
        </Button>
        <Button icon={<CloseOutlined />} danger style={{ flex: "1 1 0" }}
          disabled={item.status === "rejected"}
          onClick={() => { setPopupType("reject"); setPopupRecord(item); setPopupVisible(true); }}>
          Reject
        </Button>
        <Button icon={<DeleteOutlined />} danger style={{ flex: "1 1 100%" }}
          onClick={() => { setPopupType("delete"); setPopupRecord(item); setPopupVisible(true); }}>
          Delete Permanently
        </Button>
      </div>
    </Card>
  );

  const sidebarWidth = isMobile ? 0 : collapsed ? 0 : 240;

  const modalWidth = () => {
    if (isMobile) return "95vw";
    return popupType === "view" ? 600 : 420;
  };

  return (
    <Layout style={{ minHeight: "100vh", background: "#f5f7fa" }}>
      <Sidebar
        collapsed={collapsed} setCollapsed={setCollapsed}
        mobileOpen={mobileOpen} setMobileOpen={setMobileOpen}
        isMobile={isMobile} collapsedWidth="0" role="admin"
      />

      <Layout style={{ marginLeft: sidebarWidth, transition: "margin-left 0.3s" }}>

        {/* ── Header ── */}
        <Header
          style={{
            background: "#fff",
            padding: isMobile ? "0 12px" : "0 24px",
            height: "auto",
            minHeight: 64,
            display: "flex",
            alignItems: "center",
            gap: 10,
            borderBottom: "1px solid #f0f0f0",
            position: "sticky",
            top: 0,
            zIndex: 100,
            boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
          }}
        >
          {isMobile && (
            <Button type="text" icon={<MenuOutlined />}
              onClick={() => setMobileOpen(true)}
              style={{ fontSize: 18, padding: 0, flexShrink: 0 }}
            />
          )}
          <Text strong style={{ fontSize: isMobile ? 15 : 20, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
            User Submitted Variations
          </Text>
        </Header>

        {/* ── Content ── */}
        <Content style={{ padding: isMobile ? "12px 10px" : "20px 24px" }}>
          <Card style={{ borderRadius: 16, boxShadow: "0 6px 20px rgba(0,0,0,0.07)" }}>
            {isMobile ? (
              loading ? (
                <div style={{ textAlign: "center", padding: 40 }}><Spin /></div>
              ) : data.length === 0 ? (
                <Text type="secondary">No variations found.</Text>
              ) : (
                data.map((item) => <MobileCard key={item._id} item={item} />)
              )
            ) : (
              <Table
                columns={columns} dataSource={data}
                rowKey="_id" loading={loading}
                pagination={{ pageSize: 6 }}
                scroll={{ x: true }}
              />
            )}
          </Card>
        </Content>
      </Layout>

      {/* ── Modal ── */}
      <ModernModal
        open={popupVisible}
        title={
          popupType === "view"    ? "Variation Details"
          : popupType === "approve" ? "Approve Variation"
          : popupType === "reject"  ? "Reject Variation"
          : popupType === "edit"    ? "Edit Variation"
          : "Delete Variation"
        }
        onCancel={() => setPopupVisible(false)}
        cancelText="Close"
        onOk={
          popupType === "approve" ? handleApprove
          : popupType === "reject" ? handleReject
          : popupType === "delete" ? handleDelete
          : () => setPopupVisible(false)
        }
        okText={
          popupType === "approve" ? "Approve"
          : popupType === "reject" ? "Reject"
          : popupType === "delete" ? "Delete"
          : "Close"
        }
        showFooter={popupType !== "view"}
        width={modalWidth()}
        style={isMobile ? { top: 12 } : {}}
        centered={!isMobile}
      >
        {/* ── View ── */}
        {popupType === "view" && (
          <>
            {popupLoading ? (
              <div style={{ textAlign: "center", padding: 32 }}><Spin size="large" /></div>
            ) : popupRecord ? (
              <Descriptions bordered size="small" column={1}
                labelStyle={isMobile ? { width: 110, fontSize: 12 } : {}}
                contentStyle={isMobile ? { fontSize: 12 } : {}}
              >
                <Descriptions.Item label="Name">{popupRecord?.name}</Descriptions.Item>
                <Descriptions.Item label="Sanskrit">{popupRecord?.sanskrit}</Descriptions.Item>
                <Descriptions.Item label="English">{popupRecord?.english}</Descriptions.Item>
                <Descriptions.Item label="Pose Type">
                  {parseTypes(popupRecord?.poseType).join(", ")}
                </Descriptions.Item>
                <Descriptions.Item label="Status">
                  {popupRecord?.status === "pending" ? (
                    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                      <span>Pending</span><MdPending color="#d36a0e" />
                    </div>
                  ) : (
                    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                      <span>Approved</span><FaCircleCheck color="#34c608" />
                    </div>
                  )}
                </Descriptions.Item>
                <Descriptions.Item label="Media Link">
                  <a href={popupRecord?.mediaLink} target="_blank" rel="noreferrer"
                    style={{ wordBreak: "break-all", fontSize: isMobile ? 11 : 13 }}>
                    {popupRecord?.mediaLink}
                  </a>
                </Descriptions.Item>
                <Descriptions.Item label="Parent Asana">
                  {popupRecord?.parentAsana?.name}
                </Descriptions.Item>
                <Descriptions.Item label="Start Date">
                  {formDate(popupRecord?.mediaLinkStartDate)}
                </Descriptions.Item>
                <Descriptions.Item label="Expiry Date">
                  {formDate(popupRecord?.mediaLinkExpiryDate)}
                </Descriptions.Item>
                <Descriptions.Item label="Image">
                  <Image
                    width={isMobile ? "100%" : 260}
                    src={popupRecord?.image}
                    style={{ borderRadius: 10, boxShadow: "0 4px 14px rgba(0,0,0,0.2)" }}
                  />
                </Descriptions.Item>
              </Descriptions>
            ) : (
              <Text type="secondary">No Data Found</Text>
            )}
            <div style={{ position: "absolute", top: 10, right: 10 }}>
              <Button onClick={() => setPopupVisible(false)}><CloseOutlined /></Button>
            </div>
          </>
        )}

        {/* ── Approve ── */}
        {popupType === "approve" && (
          <p>Are you sure you want to <strong style={{ color: "#10b981" }}>Approve</strong> this variation?</p>
        )}

        {/* ── Edit ── */}
        {popupType === "edit" && (
          <Form layout="vertical" form={editForm} onFinish={handleUpdate} disabled={updateLoading}>
            <Form.Item label="Name" name="name" rules={[{ required: true }]}>
              <Input />
            </Form.Item>
            <Form.Item label="Sanskrit" name="sanskrit">
              <Input />
            </Form.Item>
            <Form.Item label="English" name="english">
              <Input />
            </Form.Item>
            <Form.Item label="Country" name="country"
              rules={[{ required: true, message: "Please select country" }]}>
              <Select showSearch placeholder="Select country"
                options={countryOptions} optionFilterProp="label"
                getPopupContainer={(node) => node.parentNode}
              />
            </Form.Item>
            <Form.Item label="Pose Type (comma separated)" name="poseType">
              <Input placeholder="seated, forward" />
            </Form.Item>
            <Form.Item label="Media Link" name="mediaLink"
              rules={[{ type: "url", message: "Enter valid URL" }]}>
              <Input />
            </Form.Item>
            <Form.Item name="parentAsana" hidden><Input /></Form.Item>
            <Form.Item label="Current Image">
              <Image width={isMobile ? 120 : 160} src={popupRecord?.image} style={{ borderRadius: 8 }} />
            </Form.Item>
            <Form.Item label="Upload New Image">
              <Upload listType="picture-card" maxCount={1}
                beforeUpload={(file) => { setImageFile(file); return false; }}>
                {!imageFile && (
                  <div><PlusOutlined /><div style={{ marginTop: 8 }}>Upload</div></div>
                )}
              </Upload>
            </Form.Item>
            <Button type="primary" htmlType="submit" block loading={updateLoading}>
              {updateLoading ? "Updating..." : "Update"}
            </Button>
          </Form>
        )}

        {/* ── Reject ── */}
        {popupType === "reject" && (
          <p>Are you sure you want to <strong style={{ color: "red" }}>Reject</strong> this variation?</p>
        )}

        {/* ── Delete ── */}
        {popupType === "delete" && (
          <p>Are you sure you want to <strong style={{ color: "red" }}>Delete Permanently</strong> this variation?</p>
        )}
      </ModernModal>

      <SuccessPopup open={successPopup} onClose={() => setSuccessPopup(false)}
        message="Variation updated successfully!" navigate="/var-approval" />
      <ErrorPopup open={errorPopup} onClose={() => setErrorPopup(false)}
        message="Upload failed. Try again." />
    </Layout>
  );
};

export default AdminVariationApproval;